<template>
  <v-list-item :class="itemClass">
    <v-list-item-avatar>
      <v-avatar
        class="grey white--text"
        size="30"
        >{{ userInitials }}</v-avatar
      >
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        <span :title="participant.identity">{{ participant.identity }}</span>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-icon>
      <v-icon>{{ userAudioIcon }}</v-icon>
      <v-icon>{{ userVideoIcon }}</v-icon>
      <v-icon>{{ userChatIcon }}</v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
import { initials } from "@/utils/string"
export default {
  name: "Participant",
  props: {
    participant: {
      type: Object,
      required: true
    }
  },
  computed: {
    itemClass() {
      return this.participant.isVisioUser ? "px-1" : "px-1 disabled"
    },
    userInitials() {
      return initials(this.participant.identity)
    },
    userAudioIcon() {
      return this.participant.isAudioActivated ? "mdi-volume-high" : "mdi-volume-off"
    },
    userChatIcon() {
      return this.participant.isChatUser ? "mdi-chat" : "mdi-chat-remove"
    },
    userVideoIcon() {
      return this.participant.isVideoActivated ? "mdi-video" : "mdi-video-off"
    }
  }
}
</script>

<style>
.disabled {
  opacity: 0.4;
}
</style>
